import queryString from 'query-string';

import { defaultTripsTrailheadsState } from '../reducers';

// parses the URL query params to hydrate app state
const parseQueryParams = () => {
  const search = window.location.search;
  if (!search.length) return {};

  const parsed = queryString.parse(search);
  const keys = Object.keys(parsed);

  if (keys.indexOf('type') === -1 || keys.indexOf('id') === -1) return {};

  for (const key in parsed) {
    if (key === 'id') {
      parsed.id = +parsed.id;
    }
    if (key === 'type') {
      parsed.type = parsed.type === 'trailheads';
    }
  }

  return parsed;
}

// formats an object representing part of app state for consumption by Redux's createStore()
export const preloadedState = () => {
  const parsed = parseQueryParams();

  return {
    sidebar: {
      open: true,
      trailheads: parsed.type === undefined ? true : parsed.type,
    },
    tripsTrailheads: {
      ...defaultTripsTrailheadsState,
      selected: parsed.id,
      selector: parsed.id ? 'list' : undefined,
    }
  }
}



// WEBPACK FOOTER //
// ./map/common/api.js